import {
  Avatar,
  Box,
  IconButton,
  InputAdornment,
  InputBase,
  makeStyles,
  Theme,
} from '@material-ui/core';
import { Send } from '@material-ui/icons';
import React, { useRef, useState } from 'react';
import CommentItem from './CommentItem';

interface IProps {
  commentation: Commentation;
  reply: boolean;
  onReply: (
    parentId: string,
    value: string,
    hideInput: (success: boolean) => void
  ) => void;
}
const inputLimit = 5000;
const useStyles = makeStyles((theme: Theme) => ({
  avatar: {
    height: '28px',
    width: '28px',
  },
  textfield: {
    backgroundColor: 'white',
    borderRadius: 4,
    padding: `${theme.spacing(0.5)}px ${theme.spacing(1)}px`,
  },
}));
const Commentation: React.FC<IProps> = ({
  commentation,
  onReply,
  reply = true,
}) => {
  const { avatar, textfield } = useStyles();
  const [message, setMessage] = useState('');
  const inputRef = useRef<HTMLInputElement | null>(null);
  const [showInputField, setShowInputField] = useState<boolean>(false);
  const [replying, setReplying] = useState<boolean>(false);

  const handleReplyChange = (
    event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>
  ) => {
    event.persist();
    setMessage(event.target.value);
  };
  const hideInputField = (success: boolean) => {
    setReplying(false);
    success && setShowInputField(false);
  };
  const handleClickReply = () => {
    setShowInputField(true);
    inputRef.current?.focus();
  };
  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (message === '') return;
    setReplying(true);
    onReply(commentation.comment.docId!, message, hideInputField);
  };
  return (
    <>
      <Box display='flex' bgcolor='#454057' p={2} flexDirection='column'>
        <Box display='flex'>
          <Box
            width='60px'
            display='flex'
            flexDirection='column'
            alignItems='center'
          >
            <Avatar className={avatar} src={commentation.comment.avatar} />
            {commentation.replies && commentation.replies.length > 0 && (
              <Box bgcolor='#564F70' width={3} height='100%' m={1} />
            )}
          </Box>
          <Box flexGrow={1}>
            <CommentItem
              comment={commentation.comment}
              onClickReply={handleClickReply}
              reply={reply}
            />
            {commentation.replies &&
              commentation.replies.length > 0 &&
              commentation.replies.map(
                (replyComment: IComment, index: number) => (
                  <CommentItem
                    comment={replyComment}
                    reply={reply}
                    key={`reply-${index}`}
                    avatar
                    onClickReply={handleClickReply}
                  />
                )
              )}
            {showInputField && reply && (
              <form onSubmit={handleSubmit}>
                <Box display='flex' bgcolor='#454057' pr={2}>
                  <InputBase
                    autoFocus
                    inputRef={inputRef}
                    disabled={replying}
                    className={textfield}
                    fullWidth
                    placeholder='เขียนข้อความตอบกลับ...'
                    onChange={handleReplyChange}
                    inputProps={{ maxLength: inputLimit }}
                    endAdornment={
                      message !== '' && (
                        <InputAdornment position='end'>
                          <IconButton
                            color='secondary'
                            edge='end'
                            type='submit'
                          >
                            <Send />
                          </IconButton>
                        </InputAdornment>
                      )
                    }
                  />
                </Box>
              </form>
            )}
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default Commentation;
